import { ADDITONAL_PREDEFINE_SECTIONS, COOKIE_DOMAIN, TPLTS } from '../../constants/constants';
import WpAPI from '../../WpApi';
import { v4 as uuidv4 } from 'uuid';
import { compareResumeObjects, getDateTime } from '../../helper';
import Cookies from 'js-cookie';
import initialData from '../../initial-data';
import { canProceedWithResumeAction, hasReachedResumeLimit, showResumeLimitAlert } from '../../utils/resumeLimitCheck';
export const HEADING = 'HEADING';
export const EDIT_INPUTBOX = 'EDIT_INPUTBOX';
export const BACK_BUTTON = 'BACK_BUTTON';
export const SAVE_RESUME = 'SAVE_RESUME';
export const GOTO_PAGE = 'GOTO_PAGE';
export const SIGNUP = 'SIGNUP'
export const SET_LOGIN_HASH = 'SET_LOGIN_HASH'
export const SET_INITIAL_DATA = 'SET_INITIAL_DATA'
export const ONNEXT_CLICK = 'ONNEXT_CLICK'
export const NUTERALIZE_NEXT_CLICK = 'NUTERALIZE_NEXT_CLICK'
export const ONBACK_CLICK = 'ONBACK_CLICK'
export const NUTERALIZE_BACK_CLICK = 'NUTERALIZE_BACK_CLICK'
export const PREVIEW_RESUME = 'PREVIEW_RESUME'
export const WITHOUT_MERGE = 'WITHOUT_MERGE'
export const ONSKIP_CLICK = 'ONSKIP_CLICK'
export const STORE_VERSION = 'STORE_VERSION'
export const UPDATE_REDUCER = 'UPDATE_REDUCER'
export const UPDATE_RB_SECTION_COMPLETENESS = 'UPDATE_RB_SECTION_COMPLETENESS'
export const SET_DOWNLOAD_FORMAT = 'SET_DOWNLOAD_FORMAT'
export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_MEMBERSHIP_DATA = 'SET_MEMBERSHIP_DATA'
export const SET_CONTEXT_MENU = 'SET_CONTEXT_MENU'
export const COVERLETTER_UPDATE = 'COVERLETTER_UPDATE'
export const INITIALIZE_COVER_LETTER = 'INITIALIZE_COVER_LETTER'
export const SAVE_AI_CHAT = 'SAVE_AI_CHAT'
export const setInitialData = (loginHash, currentResume, resume, user) => {
    const action_data = {
        type: SET_INITIAL_DATA,
    }
    if (loginHash){
        action_data['loginHash'] = loginHash
    }
    if (currentResume){
        action_data['currentResume'] = currentResume
    }
    if (resume){
        action_data['resume'] = resume
    }
    if (user){
        action_data['user'] = user
    }

    return action_data;
};



export const onInputBoxEdit = (value) => {
    //console.log('Input Value:', value);
    return ({
        type: EDIT_INPUTBOX,
        payload: value
    });
};

export const onButtonClick = (value) => {
    //console.log('This is back button click event');
    return ({
        type: BACK_BUTTON,
        payload: value
    });
};

export const gotoURL = (data) => {
    //console.log('Action gotoPage', data);
    return ({
        type: GOTO_PAGE,
        payload: data
    });
};

export const onNextClick = () => {
    return ({
        type: ONNEXT_CLICK,
        payload: { next_clicked: true }
    });
}

export const nuteralizeNextClick = (next_label, saveit, nextModule) => {
    return function (dispatch, getState) {
        let payload
        const { resume } = getState()
        saveit && resume.hasOwnProperty('modified_date') && (resume.modified_date = getDateTime())
        nextModule && (resume.enabled_tabs = Array.from(new Set([...resume.enabled_tabs, nextModule])))
        payload = {
            next_clicked: false,
            skip_clicked: false,
            ...next_label,
            resume
        }
        Promise.resolve(dispatch(
            ({
                type: ONNEXT_CLICK,
                payload
            })
        )).then(() => {
            // debugger
            //All good
            saveit && WpAPI.saveState(getState(), saveit)
            //Save for preview also in development
            // WpAPI.saveState(getState())
        })
    }
    // return ({
    //     type: ONNEXT_CLICK,
    //     next_clicked: false,
    //     ...next_label

    // })
}

export const onBackClick = () => {
    return ({
        type: ONBACK_CLICK,
        back_clicked: true
    });
}

export const nuteralizeBackClick = (next_label) => {
    return ({
        type: ONBACK_CLICK,
        back_clicked: false,
        ...next_label

    })
}

export const onSkipClick = () => {
    return ({
        type: ONSKIP_CLICK,
        skip_clicked: true,
        next_clicked: true
    });
}
export const saveAIChat = (data) => {
    return ({
        type: SAVE_AI_CHAT,
        data

    })
}
export const saveResume = (details, step, forcesave = false, assignResumeToCurrentId = true) => {
    return function (dispatch, getState) {
        Promise.resolve(dispatch(
            ({
                type: step,
                payload: details
            })
        )).then(() => {
            // debugger
            (step == SAVE_RESUME || forcesave) && WpAPI.saveState(getState(), true, assignResumeToCurrentId)
            //Save for preview also in development
            // WpAPI.saveState(getState())
        })
    };
}
export const saveCoverLetter = (details, saveit = false) => {
    return function (dispatch, getState) {
        Promise.resolve(dispatch(
            ({
                type: COVERLETTER_UPDATE,
                payload: {...details}
            })
        )).then(() => {
            saveit && WpAPI.saveCoverLetter(getState(), true)
        })
    };
}
/*
* saveit false: only save in redux state
* saveit true: only save in redux + localstorage, no db
*/
export const savePreviewCoverLetter = (details, saveit = false) => {
    return function (dispatch, getState) {
        Promise.resolve(dispatch(
            ({
                type: COVERLETTER_UPDATE,
                payload: {...details}
            })
        )).then(() => {
            saveit && WpAPI.saveCoverLetter(getState(), false)
        })
    };
}


export const signUp = (details) => {
    return function (dispatch, getState) {
        return WpAPI.signUp(details.user, details.password, details.confirmpassword, details.token).then(({ loginHash, cookie_name, auth_cookie_name, user }) => {
            dispatch({
                type: SET_LOGIN_HASH,
                loginHash: loginHash,
                user: user
            })
            return { msg: 'success', loginHash: loginHash, cookie_name: cookie_name, auth_cookie_name: auth_cookie_name}

        }).catch((e) => {
            throw (e)
        })

    }
}

export const login = (details) => {
    return function (dispatch, getState) {
        return WpAPI.login(details.user, details.password).then(({loginHash, user}) => {
            dispatch({
                type: SET_LOGIN_HASH,
                loginHash: loginHash,
                user: user
            })
            return { msg: 'success', loginHash: loginHash, user: user}
        })
        .catch((e) => {
            throw (e)
        })
    }
}

export const socialLogin = (user_info, social_login) => {
    return function (dispatch, getState) {
        return WpAPI.socialLogin(user_info, social_login).then((res) => {
            if(res.status === 'ok'){
                dispatch({
                    type: SET_LOGIN_HASH,
                    loginHash: res.loginHash,
                    user: res.user
                })
                return { msg: 'success', loginHash: res.loginHash, user: res.user, account_type: res.account_type}
            }else{
                return { msg: 'error', error: res.error, account_type: res.account_type}
            }
        })
        .catch((e) => {
            throw (e)
        })
    }
}

export const setLoginHash = (loginHash, user = null) => {
    return {
        type: SET_LOGIN_HASH,
        loginHash: loginHash,
        user: user
    }
}

export const uploadResume = (fileupload) => {
    return function (dispatch, getState) {
        console.log('upload started')
        return WpAPI.uploadResume(fileupload).then((resume) => {
            // console.log('resumeeee',resume)
            Cookies.remove('current_resume', { domain: COOKIE_DOMAIN, path: "/" })
            const c = localStorage.getItem('selected_color')
            const t = localStorage.getItem('selected_template')
            const cc = localStorage.getItem('selected_custom_color')
            Cookies.remove('current_resume', { domain: COOKIE_DOMAIN, path: "/" })
            WpAPI.fetchActiveResume(dispatch, ()=>{
                dispatch(saveResume(
                    {
                        ...resume, 
                        active_color: c ? c : 'color-variant-blue',
                        active_template: t ? t : 'template-one',
                        custom_template_color: cc ?? '',
                        created_date: getDateTime(),
                        modified_date: getDateTime()
                    },
                    PREVIEW_RESUME,
                    true))
            })
            localStorage.removeItem('selected_color')
            localStorage.removeItem('selected_template')
            localStorage.removeItem('selected_custom_color')
        }).then((resp => {
            // dispatch(saveResume(resp, PREVIEW_RESUME, true))
            // Cookies.set('rbuser', action.loginHash);
            // console.log('redirect here')
            return { msg: 'success' }
        })).catch((e) => {
            throw (e)
        })
    }
}

export const uploadProfileImage = (fileupload) => {
    return function (dispatch, getState) {
        console.log('image upload started..!!')
        return WpAPI.uploadPicture(fileupload).then((res) => {
            const { resume } = getState();
            if (res.status == 200 && res.data.hasOwnProperty('success') && res.data.picture_path != '') {
                dispatch(saveResume(
                    {
                        heading: {
                            ...resume.heading,
                            profile_picture: {
                                picture_path: res.data.picture_path,
                                picture_abs_path: res.data.picture_abs_path
                            }
                        }
                    },
                    PREVIEW_RESUME, false))
                return res.data.image_name;
            }
        }).then((resp => {
            return { msg: 'success', name: resp }
        })).catch((e) => {
            throw (e)
        })
    }
}

export const uploadTopResumeFile = (fileupload) => {
    return function (dispatch, getState) {
        console.log('Resume File upload started..!!')
        return WpAPI.uploadTopResumeFile(fileupload).then((res) => {
            //const { resume } = getState();
            if (res.status == 200 && res.data.hasOwnProperty('success') && res.data.topresume_path != '') {
                return res.data;
            }
        }).then((resp => {
            return { msg: 'success', data: resp }
        })).catch((e) => {
            throw (e)
        })
    }
}

export const submitFormData = (fdata) => {
    return function (dispatch, getState) {
        console.log('Form Submission started..!!')
        return WpAPI.submitTopResumeData(fdata).then((res) => {
            //const { resume } = getState();
            if (res.status == 200) {
                return res.data;
            }
        }).then((resp => {
            return { msg: 'success', data: resp }
        })).catch((e) => {
            throw (e)
        })
    }
}

export const createNewResume = () => {
    return function (dispatch, getState) {
        // Check resume limit before creating
        if (!canProceedWithResumeAction('create')) {
            return;
        }
        
        const c = localStorage.getItem('selected_color')
        const t = localStorage.getItem('selected_template')
        const cc = localStorage.getItem('selected_custom_color')
        Cookies.remove('current_resume', { domain: COOKIE_DOMAIN, path: "/" })
        try{
            WpAPI.fetchActiveResume(dispatch, ()=>{
                dispatch(saveResume(
                    {
                        active_color: c ? c : 'color-variant-blue',
                        active_template: t ? t : 'template-one',
                        custom_template_color: cc ?? '',
                        summary: {content: ''},
                        created_date: getDateTime(),
                        modified_date: getDateTime()
                    },
                    PREVIEW_RESUME,
                    true))
            })
        }catch (error) {
            console.error("Caught an error when fetching active resumes:", error);
        }
        localStorage.removeItem('selected_color')
        localStorage.removeItem('selected_template')
        localStorage.removeItem('selected_custom_color')
    }
}

export const updateEditor = (editorType) => {
    return function (dispatch, getState) {
        WpAPI.fetchActiveResume(dispatch, () => {
            let obj = {
                active_editor: editorType ?? 'traditional',
            }
            dispatch(saveResume(
                    obj,
                    PREVIEW_RESUME,
                    true
                )
            )
        })
    }
}

export const updateTemplate = (customColor, color, tpl) => {
    return function (dispatch, getState) {
        let obj = {
            active_color: color ? color : 'color-variant-blue',
            active_template: tpl ? tpl : 'template-one',
            custom_template_color: customColor ? customColor : ''
        }
       
        if(getState().resume.created_date == '')
        {
            WpAPI.fetchActiveResume(dispatch, ()=>{
            let obj = {
                active_color: color ? color : 'color-variant-blue',
                active_template: tpl ? tpl : 'template-one',
                custom_template_color: customColor ? customColor : ''
            }
            // If resume starts from choose-template page then initialize created_date.
                obj = getState().resume.created_date != '' ? { ...getState().resume, ...obj, modified_date: getDateTime() } : { ...obj, created_date: getDateTime() };

            dispatch(saveResume(
                obj,
                PREVIEW_RESUME,
                true))
        })}else{
        dispatch(saveResume(
            { ...getState().resume, ...obj},
            PREVIEW_RESUME,
            true))
        }
    }
}

export const withoutMerge = (resume => {
    return ({
        type: WITHOUT_MERGE,
        payload: resume
    });
})

export const deleteSection = (name) => {
    return function (dispatch, getState) {
        let resume = { ...getState().resume }
        delete resume[name]
        dispatch(withoutMerge(resume))
    }
}

export const loadResume = (id) => {
    return function (dispatch, getState) {
        return new Promise((resolve, reject) => {
            Cookies.set('current_resume', id, { domain: COOKIE_DOMAIN, path: '/' })
            WpAPI.fetchActiveResume(dispatch, () => {
                const s = getState()
                resolve(s)
            })
        }).then((r) => {

            return { msg: 'success', ...r }
        }).catch((e) => {
            throw (e)
        })

    }
}

export const loadLetter = (id) => {
    return async function (dispatch, getState) {
        try {
            const r = await new Promise((resolve, reject) => {
                Cookies.set('current_letter', id, { domain: COOKIE_DOMAIN, path: '/' });
                WpAPI.fetchActiveLetter(dispatch, () => {
                    const s = getState();
                    resolve(s);
                });
            });
            return { msg: 'success', ...r };
        } catch (e) {
            throw (e);
        }

    }
}

export const generateEntityLink = (data, user_id, type, entity = {type: 'resume', name: 'Resume'}) => {
    return function (dispatch, getState) {
        const f1 = entity.type == 'resume' ? 'generateResumeLink' :  'generateLetterLink'
        const linkfield =  entity.type == 'resume' ? 'resume_link' :  'cover_link'
        return new Promise((resolve, reject) => {
            WpAPI[f1]( data.id, user_id).then((res, error) => {
                if(res?.link){
                    //Commented this, let link be generated everytime
                    // if(type == 'currentResume'){
                    //     dispatch(saveResume(
                    //         {...data, [linkfield]: res.link},
                    //         PREVIEW_RESUME,
                    //         true
                    //     ))
                    // }else{
                        // dispatch(loadResume(data.id)).then(resp => {
                        // dispatch(
                        //     saveResume(
                        //         {...resp[entity.name], [linkfield]: res.link},
                        //         PREVIEW_RESUME,
                        //         true
                        //     ))
                        // })
                    // }
                    resolve(res)
                }else{
                    reject(error)
                }
            }).catch((e) => {
                console.log(e)
            })
        }).catch((e) => {
            console.log(e)
        })
    }
}

export const duplicateResume = (resume_id, resume_name = '', type = 'list') => {
    const loginHash = Cookies.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"});
    return function (dispatch, getState) {
        // Check resume limit before duplicating
        if (!canProceedWithResumeAction('duplicate')) {
            return Promise.reject('Resume limit reached');
        }
        
        return new Promise((resolve, reject) => {
            WpAPI.duplicateResume(resume_id, resume_name).then( res => {
                // dispatch(saveResume(
                //     res.resume,
                //     PREVIEW_RESUME,
                //     true))
                if(type == 'currentResume'){
                    delete res.resume.resume_name;
                    dispatch(saveResume(
                        res.resume,
                        PREVIEW_RESUME,
                        true,
                        false
                    ))
                }else{
                    dispatch(loadResume(res.currentResume)).then(resp => {
                        dispatch(
                            saveResume(
                                resp.resume,
                                PREVIEW_RESUME,
                                true,
                                false
                            )
                        )
                    })
                    dispatch(setInitialData(loginHash ? loginHash : null, res.currentResume, res.resume))
                }
                resolve(res.resumes);
            })
        })
    }
}

export const duplicateLetter = (letter_id, letter_name = '', type = 'list') => {
    const loginHash = Cookies.get('rbuser', { domain: COOKIE_DOMAIN, path: "/" });
    return function (dispatch, getState) {
        // Check resume limit before duplicating letter (letters count toward resume limit)
        if (!canProceedWithResumeAction('duplicate')) {
            return Promise.reject('Resume limit reached');
        }
        
        return new Promise((resolve, reject) => {
            // if (letter_id == null) {
            //     const newId = uuidv4();
            //     WpAPI.saveCoverLetter(getState(), true, newId)
            //     resolve('completed')
            // } else {
                WpAPI.duplicateLetterInLocalStorage(letter_id, letter_name).then(res => {
                    
                    WpAPI.saveCoverLetter({coverletter: res.letter, loginHash: getState().loginHash}, true, res.new_id);

                    // dispatch(loadLetter(res.currentLetter)).then(resp => {
                    //     dispatch(
                    //         saveCoverLetter(
                    //             resp.letter,
                    //             true
                    //         )
                    //     )
                    // })
                    // dispatch(initializeCoverletter(loginHash ? loginHash : null, res.currentLetter, res.letter))
                    resolve(type == 'list' ? res.letters :  'completed' );
                })
            // }
        })
    }
}

export const setVersion = (resume) => {
    return {
      type: STORE_VERSION,
      resume: resume
    }
}

export const AISearchResponse = (section, phrase) => {
    return function (dispatch, getState) {
        return new Promise((resolve, reject) => {
            WpAPI.getPhraseDataByAI(section, phrase).then( (res, error) => {
                if(res.status === 'ok'){
                    dispatch({
                        type: UPDATE_REDUCER,
                        payload: {aidata: res.output}
                    })
                    resolve({status: "ok", aidata: res.output})
                }else{
                    reject({status: "error", error: error})
                }
            })
        }).catch(e => {
            reject({status: "error", error: error})
        })
    }
}

export const updateAISearchResponse = (aidata) => {
    return {
        type: UPDATE_REDUCER,
        payload: {aidata: aidata}
    }
}

export const setResumeFormat = (downloadFormat) => {
    return {
        type: SET_DOWNLOAD_FORMAT,
        downloadFormat: downloadFormat
    }
}

export const saveUser = (user) => {
    return {
        type: SET_USER_DATA,
        payload: user
    }
}

export const setMembershipData = (membership) => {
    return {
        type: SET_MEMBERSHIP_DATA,
        payload: membership
    }
}

export const userCompletesSectionsDownloadsPrintsOrShares = (resume, type) => {
    return function (dispatch, getState) {
        return new Promise((resolve, reject) => {
            WpAPI.userCompletesSectionsDownloadsPrintsOrShares(resume).then( res => {
                if(res.completed){
                    if(type == 'currentResume'){
                        dispatch(saveResume(
                            {...resume, user_completes_sections_downloads_prints_or_shares: res.completed},
                            PREVIEW_RESUME,
                            true
                        ))
                    }else{
                        dispatch(loadResume(resume.id)).then(resp => {
                        dispatch(
                            saveResume(
                                {...resp.resume, user_completes_sections_downloads_prints_or_shares: res.completed},
                                PREVIEW_RESUME,
                                true
                            ))
                        })
                    }
                }
                resolve({completed: res.completed});
            })
        })
    }
}

export const setContextMenu = (contextMenu) => {
    return {
        type: SET_CONTEXT_MENU,
        payload: contextMenu
    }
}
export const loadCoverletterQA = () =>{
    return function (dispatch, getState) {
    const obj = JSON.parse(localStorage.getItem('clobj'))
        if(!getState().coverletter.qa_steps_initiated && obj){
        // if(obj){
            dispatch(
                ({
                    type: COVERLETTER_UPDATE,
                    payload: {...obj}
                }))
        }
    }
}
export const initiateCoverLetterQA = (customColor, color, tpl, exp = null) => {
    return function (dispatch, getState) {
        let obj = {
            active_color: color ? color : '',
            active_template: tpl ? tpl : 'template-eleven',
            custom_template_color: customColor ? customColor : '',
            qa_steps_initiated: true
        }
        obj = { ...initialData.coverletter, ...obj };
        obj.ques_ans_response.experience = exp;
        
        Promise.resolve(dispatch(
            ({
                type: COVERLETTER_UPDATE,
                payload: {...obj}
            })
        )).then(() => {
            localStorage.setItem('clobj', JSON.stringify(getState().coverletter));
            localStorage.removeItem('cl_color')
            localStorage.removeItem('cl_tpl')
            localStorage.removeItem('cl_custom_color')
            localStorage.removeItem('cl_builder')
        })
    }
}
export const createCoverLetter = () => {
    return function (dispatch, getState) {
        WpAPI.fetchActiveLetter(dispatch, () => {
            const obj = JSON.parse(localStorage.getItem('clobj'))
            dispatch(saveCoverLetter(obj, true))
            localStorage.removeItem('clobj')
        })
    }
}
export const saveCoverLetterQA = (obj) => {
    return function (dispatch, getState) {
        Promise.resolve(dispatch(
            ({
                type: COVERLETTER_UPDATE,
                payload: {...obj}
            })
        )).then(() => {
            localStorage.setItem('clobj', JSON.stringify( getState().coverletter));
        })
    };
}
export const updateCoverLetterTemplate = (customColor, color, tpl, exp = null) => {
    return function (dispatch, getState) {
        let obj = {
            active_color: color ? color : 'color-variant-blue',
            active_template: tpl ? tpl : 'template-one',
            custom_template_color: customColor ? customColor : ''
        }
        dispatch(saveCoverLetter(
            { ...getState().coverletter, ...obj},
            true))
        }
}
export const initializeCoverletter = (loginHash, currentletter, coverletter, user) => {
    const action_data = {
        type: INITIALIZE_COVER_LETTER,
    }
    if (loginHash) action_data['loginHash'] = loginHash
    if (currentletter) action_data['currentLetter'] = currentletter
    if (coverletter) action_data['coverletter'] = coverletter
    if (user) action_data['user'] = user
    return action_data;

}
// export const resumeReview = (resume = null, saveit = true) => {
//     return function (dispatch, getState) {
//         return new Promise((resolve, reject) => {
//             WpAPI.reviewResume(resume ? {resume: resume} : getState(), 'full').then( res => {
//                 // if(res.status === 'ok'){
//                     dispatch({
//                         type: PREVIEW_RESUME,
//                         payload: { resume_review: {...res}}
//                     })
//                     resolve(res);
//                 // }else{
//                 //     reject(res.error);
//                 // }
//             })
//         })
//     }
// }
export const resumeReview = (resume = null, saveit = true, id = null) => {
    return function (dispatch, getState) {
        return new Promise((resolve, reject) => {
            WpAPI.reviewResume(resume ? {resume: resume} : getState(), 'full').then( res => {
                // if(res.status === 'ok'){
                    //First condition is just to make sur current resume is not changed during the process, otherwise wrong resume will be updated
                   (!id || id == Cookies.get('current_resume', { domain: COOKIE_DOMAIN, path: '/' })) && dispatch(saveResume(
                        { resume_review: {...res}, resume_reviewed_time:getDateTime()},PREVIEW_RESUME, saveit) )
                    resolve(res);
                // }else{
                //     reject(res.error);
                // }
            })
        })
    }
}
export const updateFinalTargetLink = (data) => {
    return {
        type: UPDATE_REDUCER,
        payload: {redirect_to: data.link}
    }
}

export const updateUser = (user) => {
    return {
        type: UPDATE_REDUCER,
        payload: {user: user}
    }
}

export const updateProfilePictureStatus = (tpl) => {
    const activeTemplate = TPLTS.find(t => t?.resume && t.id === tpl);
    return {
        type: UPDATE_REDUCER,
        payload: {has_profile_picture: activeTemplate?.profile_picture || false}
    }
}
export const createNewResume4rmShowcase = (showcase) => {
    return function (dispatch, getState) {
        // Check resume limit before creating from showcase
        if (!canProceedWithResumeAction('create')) {
            return;
        }
        
        Cookies.remove('current_resume', { domain: COOKIE_DOMAIN, path: "/" })
        WpAPI.fetchActiveResume(dispatch, ()=>{
            dispatch(saveResume(
                {
                    ...showcase,
                    created_date: getDateTime(),
                    modified_date: getDateTime()
                },
                PREVIEW_RESUME,
                true))
        })
        // localStorage.removeItem('selected_color')
        // localStorage.removeItem('selected_template')
        // localStorage.removeItem('selected_custom_color')
    }
}
export const createNewResumewithData = (data, callback) => {
    // Remove any existing resume from cookies
    Cookies.remove('current_resume', { domain: COOKIE_DOMAIN, path: "/" });
    const c = localStorage.getItem('selected_color')
    const t = localStorage.getItem('selected_template')
    const cc = localStorage.getItem('selected_custom_color')
    return function (dispatch, getState) {
        // Check resume limit before creating with data
        if (!canProceedWithResumeAction('create')) {
            return;
        }
        
        // Create new empty resume and update with data
        WpAPI.fetchActiveResume(dispatch, () => {
            let skillset = {} ;
            (data.ai_skills || []).map((skill, index) => {
                skillset[`skill_${index + 1}`] =  { name: skill.content }
            })
            // accomplishments
            const accomplishments = {
                name:ADDITONAL_PREDEFINE_SECTIONS.accomplishments.name,
                grid: {
                    row_1: {
                        ...ADDITONAL_PREDEFINE_SECTIONS.accomplishments?.struct?.grid?.row_1,
                        content: `<ul>${
                            (data.ai_accomplishments || [])
                                .map(accomplishment => `<li>${accomplishment.content}</li>`)
                                .join('')
                        }</ul>`,
                        open: true
                    }
                }
            };
            // interest
            const interests = {
               name:ADDITONAL_PREDEFINE_SECTIONS.interests.name,
               ...ADDITONAL_PREDEFINE_SECTIONS.interests?.struct,
                    content: `<ul>${
                        (data.ai_interests || [])
                            .map(interests => `<li>${interests.content}</li>`)
                            .join('')
                    }</ul>`
            };

            const ai_data =  {
                heading: {
                    ...initialData.resume.heading,
                    fname: data.fname,
                    lname: data.lname,
                    email: data.email,
                    profession: data.jobtitle,
                },
                summary: {
                    content: data.summary || '',
                },
                skills: {
                    ...initialData.resume.skills,
                    set: {...skillset}
                },
                work_history: {
                    ...initialData.resume.work_history,
                    jobs: {
                        job_1: {
                            job: {
                                ...initialData.resume.work_history.jobs.job_1.job,
                                job_title: (data.ai_jobs?.job_1?.job_title ? data.ai_jobs.job_1.job_title : data.jobtitle),
                                description: `
                                    <ul>
                                        ${(data.ai_jobs?.job_1?.description || []).slice().map((job) => `<li>${job}</li>`).join('')}
                                    </ul>
                                `,
                            }
                        },
                         job_2: {
                            job: {
                                ...initialData.resume.work_history.jobs.job_1.job,
                                job_title: (data.ai_jobs?.job_2?.job_title ? data.ai_jobs.job_2.job_title : data.jobtitle),
                                description: `
                                    <ul>
                                        ${(data.ai_jobs?.job_2?.description || []).slice().map((job) => `<li>${job}</li>`).join('')}
                                    </ul>
                                `,
                            }
                        }
                        
                    }
                },
                accomplishments,
                interests,
                 active_color: c ? c : 'color-variant-blue',
                active_template: t ? t : 'template-one',
                enabled_tabs: ["heading", "work_history", "education", "skills", "additional_sections", "summary", "completed"],
                custom_template_color: cc ?? '',
                created_date: getDateTime(),
                modified_date: getDateTime()
            };
            dispatch(
                saveResume({
                ...ai_data
            }, PREVIEW_RESUME, true)
            );
            if (typeof callback == 'function') callback()
            localStorage.removeItem('selected_color')
            localStorage.removeItem('selected_template')
            localStorage.removeItem('selected_custom_color')

        });
    }
};
export const saveLocalRevision = (data, merge_small_interval = true) => {
    return function (dispatch, getState) {
            const state = getState()
            const _data = JSON.parse( JSON.stringify(data) )
            let revision = { resume:{..._data}, datetimestamp: Date.now() }
            let revisions = state.revisions ? [...state.revisions] : []
            let _stack = [], p
            if(revisions && revisions.length){
                const last = revisions.slice(-1)[0]
                const curr = {...state.resume}
                //Do not create version if last version is same as current
                if(compareResumeObjects(last.resume, curr)) return
                //Do not create version if span is less than 2percent
                if(merge_small_interval && (revision.datetimestamp - last.datetimestamp) < 3000 ) return
                if(state.redo_undo.pointer !== revisions.length){
                    //remove all revision ahead of pointer
                    revisions.splice( state.redo_undo.pointer)

                    // Check if previous revision exists before comparing
                    const previousRevision = revisions[state.redo_undo.pointer - 1];
                    if(previousRevision && previousRevision.resume && 
                       !compareResumeObjects(previousRevision.resume, revision.resume)) {
                        //Only if not the same revision
                        revisions.push(revision)
                    } else if (!previousRevision) {
                        // No previous revision, add this one
                        revisions.push(revision)
                    }
                     _stack = revisions
                }else _stack =  [...revisions, revision]
            } else _stack =[ revision]

            if(state.redo_undo){
                p = _stack.length
            }else p = 1
            dispatch({
                type: SET_CONTEXT_MENU,
                payload: {
                    revisions: [..._stack],
                    redo_undo:{pointer: p, enable_redo: false, enable_undo: true}
                }
            })
    };
}
export const redoAndUndoAction = (type) => {
    return function (dispatch, getState) {
        const state = getState();
        const redo_undo_data = state.redo_undo
          Promise.resolve(
            dispatch(
            {
                type: SET_CONTEXT_MENU,
                payload: {redo_undo: {...redo_undo_data, enable_redo: false, enable_undo: false}}
            })
        ).then(() => {
            if(redo_undo_data.pointer == state.revisions.length && type == 'undo'){
                let last = {...state.revisions[redo_undo_data.pointer - 1].resume}
               // delete last['modified_date']
                let curr = {...state.resume}
               // delete curr['modified_date']
                //if ( JSON.stringify(last) !== JSON.stringify(curr) ) {
                if(compareResumeObjects(last, curr) === false){
                    //Revision current before undo new
                    dispatch(saveLocalRevision({...state.resume}, false))
                    state.redo_undo.pointer = state.redo_undo.pointer + 1
                    // dispatch({
                    //     type: SET_CONTEXT_MENU,
                    //     payload: {
                    //         redo_undo:{pointer: redo_undo_data.pointer, enable_redo: false, enable_undo: false}
                    //     }
                    // })
                    // If the current and last revision differ, reject to not process further and call redoAndUndoAction(type) again
                    // reject({action: 'restart'})
                    // return Promise.reject().catch(() => dispatch(redoAndUndoAction(type)));
                }
            }
        }).then(() => {
            let revision;
            if(type == 'redo'){
                revision = state.revisions[state.redo_undo.pointer  ]
            }else if(type == 'undo'){
                revision = state.revisions[state.redo_undo.pointer - 2 ]
            }
            // delete revision['datetimestamp']
            // const keycount = Object.keys(revision).length
            //restore revision
            // if(keycount == 1 ) dispatch(saveResume(revision, PREVIEW_RESUME))
            // else dispatch(withoutMerge(revision))
            
            // Fix: Check if revision and revision.resume exist before spreading
            if (revision && revision.resume) {
                dispatch(withoutMerge({...revision.resume}))
            } else if (revision) {
                // Fallback: If revision exists but doesn't have resume property, use revision directly
                dispatch(withoutMerge({...revision}))
            } else {
                // Log error if revision itself is undefined
                console.warn('Undo/Redo: Invalid revision at pointer', state.redo_undo.pointer);
            }

        }).then(() => {
            if (type == 'undo') {
                dispatch({
                    type: SET_CONTEXT_MENU,
                    payload: {
                        redo_undo: { pointer: redo_undo_data.pointer - 1, enable_redo: true, enable_undo: redo_undo_data.pointer > 2 }
                    }
                })
            } else if (type == 'redo') {
                dispatch({
                    type: SET_CONTEXT_MENU,
                    payload: {
                        redo_undo: { pointer: redo_undo_data.pointer + 1, enable_redo: ((redo_undo_data.pointer + 1) < state.revisions.length), enable_undo: true }
                    }
                })
            }
        })
        
    }
}